import React from 'react';
import Dashboard from './dashboard/Dashboard';

const CartResQDashboard = () => {
  // Only render the main dashboard content
  return <Dashboard />;
};

export default CartResQDashboard; 